import {
  LookupProfilesResponseSchema,
  type UpdateProfileInput,
  UpdateProfileResponseSchema,
  type UserPreferences,
  UserPreferencesSchema,
} from "@recobra/schemas/user";

import { requestJson } from "./client";

export const profileApi = {
  updateProfile: (body: UpdateProfileInput) =>
    requestJson("/profile", UpdateProfileResponseSchema, {
      method: "PATCH",
      body: JSON.stringify(body),
    }),
  lookupProfiles: (userIds: string[]) =>
    requestJson("/profile/lookup", LookupProfilesResponseSchema, {
      method: "POST",
      body: JSON.stringify({ userIds }),
    }),
  getPreferences: (signal?: AbortSignal) =>
    requestJson("/profile/preferences", UserPreferencesSchema, { signal }),
  updatePreferences: (patch: UserPreferences) =>
    requestJson("/profile/preferences", UserPreferencesSchema, {
      method: "PATCH",
      body: JSON.stringify(patch),
    }),
};
